import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefFreshnessLook = 'brief-freshness-choice' | 'brief-freshness-choice-on';

const BRIEF_FRESHNESS_LOOKS = new Set<string>(['brief-freshness-choice', 'brief-freshness-choice-on']);
export const isWedgeBriefFreshnessLook = (look: string | undefined): look is WedgeBriefFreshnessLook => look !== undefined && BRIEF_FRESHNESS_LOOKS.has(look);

/* Released Brief freshness settings (ask to refresh after, auto-refresh saved briefs): one radio pill, 7px by 12px padding, a full round
   radius and 13px semibold type in the Wedge font. Unchosen, it takes the elevated fill, a 1px card border and the label ink; chosen, the
   accent tint fill, a 1px accent border and the accent ink. It keeps the declaration order of the source and reads the exact legacy
   roles. It draws no transparent target and no anchor (wedgeSettingsDrawsHit): the pills sit in a wrap row 6px apart and about 33px
   tall, so two 44px regions would overlap their neighbors and the row above. The caller owns the labels, the radio roles and the
   handlers. */
export function wedgeBriefFreshnessStyle(look: WedgeBriefFreshnessLook): CSSProperties {
  const r = wedgeExactRole;
  const on = look === 'brief-freshness-choice-on';
  return {
    padding: '7px 12px', borderRadius: 999, cursor: 'pointer',
    border: `1px solid ${r(on ? 'accent' : 'cardBorder')}`,
    background: r(on ? 'accentTint' : 'bgElev'),
    color: r(on ? 'accent' : 'label'),
    fontSize: 13, fontWeight: 600, fontFamily: r('font'),
  };
}
